import React, { useState } from 'react';

const ServiceSelectionStep = ({ onNext, formData }) => {
  const [serviceType, setServiceType] = useState(formData.serviceType || '');
  const [description, setDescription] = useState(formData.description || '');

  // TODO: Populate from a service model/config
  const serviceOptions = [
    "AC Repair",
    "Heating Installation",
    "Maintenance Plan Inquiry",
    "Indoor Air Quality Consultation",
    "Other"
  ];

  const handleNext = () => {
    if (serviceType) {
      onNext({ serviceType, description });
    }
    // TODO: Add validation feedback if serviceType is empty
  };

  return (
    <div>
      <h3 className="text-xl font-semibold text-brand-text-dark mb-4">What service do you need?</h3>
      
      <div className="mb-6">
        <label htmlFor="serviceType" className="block text-sm font-medium text-brand-text-light mb-1">Service Type <span className="text-red-600">*</span></label>
        <select 
          id="serviceType" 
          name="serviceType"
          value={serviceType}
          onChange={(e) => setServiceType(e.target.value)}
          className="mt-1 block w-full p-3 border border-gray-300 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
        >
          <option value="" disabled>Select a service</option>
          {serviceOptions.map(option => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
        {/* TODO: Add validation error message here */}
      </div>

      <div className="mb-6">
        <label htmlFor="description" className="block text-sm font-medium text-brand-text-light mb-1">Briefly describe your issue or what you're looking for (optional):</label>
        <textarea 
          id="description" 
          name="description"
          rows="3"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="e.g., My AC is not cooling, I'd like a quote for a new furnace."
          className="mt-1 block w-full p-3 border border-gray-300 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
        />
      </div>

      <div className="flex justify-end">
        <button 
          onClick={handleNext} 
          disabled={!serviceType}
          className="cta-button disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ServiceSelectionStep; 